var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#C0C6CB",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2138 16.2346L7.74736 14.2333L4.16841 23.7143L4.66406 24.0004L11.2138 16.2346ZM5.53085 0.99978L7.26264 0L19.2632 20.7848L17.531 21.7849L14.827 17.1014L3 10.273L4.27777 8.09172L6.56555 8.38524C7.4475 8.42722 8.04793 8.18027 8.76866 7.24928L8.98068 6.97553L5.53085 0.99978ZM11.4826 3.42867C11.4636 3.23676 11.3679 3.0011 11.1506 2.6896L10.601 1.90219L10.4532 1.64537L11.4166 0C14.8545 1.98474 18.2923 3.96984 21.7305 5.95458L20.7734 7.63628L19.5341 7.5301C18.4585 7.43767 18.4056 7.89064 18.2147 8.35737L16.7761 11.8728C16.7115 12.0305 16.6582 12.179 16.6156 12.3198L11.4826 3.42867Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnpin);
export default __webpack_public_path__ + "static/media/icon_unpin.b5dab71bc9bd7ec90a41ae86edd03926.svg";
export { ForwardRef as ReactComponent };